import axios from 'axios';
import { notification } from 'antd';
import * as types from 'actions/ActionTypes';

const openNotificationWithIcon = (type, message, desc) => {
	notification[type]({
		message: message,
		description: desc,
	});
};

export const api = (self, url, datas, callback) => {
	return axios
		.post(types.AI_API_URL + url, {
			params: {
				...datas,
			},
		})
		.then(res => {
			return res;
		})
		.catch(err => {
			if (err.response) {
				const userMessage = err.response.data.userMessage;
				//openNotificationWithIcon('error', '에러', userMessage);
			} else {
				openNotificationWithIcon('error', '에러', '서버에 응답이 없습니다. 잠시 후 다시 접속해 주세요.');
			}
		});
};

export const postApi = (self, url, datas, callback) => {
	return axios
		.post(types.LOCAL_API_URL + url, { contents: datas }, { withCredentials: true })
		.then(res => {
			return res;
		})
		.catch(err => {
			if (err.response) {
				const userMessage = err.response.data.userMessage;
				//openNotificationWithIcon('error', '에러', userMessage);
			} else {
				openNotificationWithIcon('error', '에러', '서버에 응답이 없습니다. 잠시 후 다시 접속해 주세요.');
			}
			if (callback) callback();
		});
};

export const isUsedValidate = () => {
	return new Promise((resolve, reject) => {
		axios.get(types.LOCAL_API_URL + '/api/used/validate', { withCredentials: true }).then(response => {
			if (response.data) {
				resolve(response.data);
			} else {
				reject(response.data);
			}
		});
	});
};
